import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SliceTypes } from 'utils';
import { geoMapInitial } from './InitialStates/geoMapInitial';
import { RootState } from './rootReducer';

export const geoMapSlice = createSlice({
    name: SliceTypes.GEO_MAP,
    initialState: geoMapInitial,
    reducers: {
        updateGeoMap: (state, { payload: { page, data, type } }: PayloadAction<any>) => {
            state.selection[page] = { ...data };
            state.selectionType = type;
        },
    },
});

export const { updateGeoMap } = geoMapSlice.actions;

export const geoMapData = (state: RootState) => state.geoMap;
export const geoMapSelection = (state: RootState) => state.geoMap.selection;
export const geoMapPermissions = (state: RootState) => state.geoMap.permissions;

export default geoMapSlice.reducer;
